import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetSection(id: string | undefined) {
  return useQuery(queries.locations.getSectionById(id || ''))
}
